/*
  Copy this file to assets/seasonal-promotions-row.js in a Shopify Online Store 2.0 theme.
  It adds lightweight arrow navigation for the Seasonal promotions row section.
*/

(() => {
  const SECTION_SELECTOR = '.shopify-section--mc-seasonal-promos';
  const SLIDER_SELECTOR = '[data-mc-seasonal-promos-slider]';
  const VIEWPORT_SELECTOR = '[data-mc-seasonal-promos-viewport]';
  const PREV_SELECTOR = '[data-mc-seasonal-promos-prev]';
  const NEXT_SELECTOR = '[data-mc-seasonal-promos-next]';
  const TRACK_SELECTOR = '.mc-seasonal-promos__track';
  const CARD_SELECTOR = '.mc-seasonal-promos__card';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getScrollStep(viewport, track) {
    const card = track.querySelector(CARD_SELECTOR);
    if (!card) return Math.max(280, Math.floor(viewport.clientWidth * 0.85));

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows(viewport, prevButton, nextButton) {
    const maxLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 1);
    const current = viewport.scrollLeft;
    const atStart = current <= 1;
    const atEnd = current >= maxLeft;

    prevButton.disabled = atStart;
    nextButton.disabled = atEnd;
    prevButton.setAttribute('aria-disabled', String(atStart));
    nextButton.setAttribute('aria-disabled', String(atEnd));
  }

  function initSlider(slider) {
    const sectionWrapper = slider.closest(SECTION_SELECTOR);
    const viewport = slider.querySelector(VIEWPORT_SELECTOR);
    const track = slider.querySelector(TRACK_SELECTOR);
    const prevButton = slider.querySelector(PREV_SELECTOR);
    const nextButton = slider.querySelector(NEXT_SELECTOR);

    if (!sectionWrapper || !viewport || !track || !prevButton || !nextButton) return;

    if (slider.dataset.mcSeasonalPromosInit === 'true') {
      updateArrows(viewport, prevButton, nextButton);
      return;
    }

    slider.dataset.mcSeasonalPromosInit = 'true';
    sectionWrapper.classList.add('mc-seasonal-promos--js');

    prevButton.addEventListener('click', () => {
      viewport.scrollBy({
        left: -getScrollStep(viewport, track),
        behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
      });
    });

    nextButton.addEventListener('click', () => {
      viewport.scrollBy({
        left: getScrollStep(viewport, track),
        behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
      });
    });

    viewport.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => updateArrows(viewport, prevButton, nextButton));
    }, { passive: true });

    window.addEventListener('resize', () => updateArrows(viewport, prevButton, nextButton), { passive: true });

    updateArrows(viewport, prevButton, nextButton);
  }

  function init(root = document) {
    root.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) init(event.target);
  });
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target) init(event.target);
  });

  init(document);
})();
